import { axiosInstance } from "../utils/axiosInstance";

export const verifyEmailService = async (email) => {
  return await axiosInstance.get(`verify_email/${email}`);
};

export const verifyMobileService = async (mobile) => {
  return await axiosInstance.get(`verify_mobile_number/${mobile}`);
};

export const verifyOtpService = async (data) => {
  return await axiosInstance.post("/verify_otp", data);
};

export const RegisterStepOne = async (data) => {
  return await axiosInstance.post("step_1", data);
};

export const RegisterStepTwo = async (data) => {
  return await axiosInstance.post("step_2", data);
};
export const RegisterStepThree = async (data) => {
  return await axiosInstance.post("step_3", data);
};
export const RegisterStepFour = async (data) => {
  return await axiosInstance.post("step_4", data);
};

export const GetApplicationReview = async (id) => {
  return await axiosInstance.get(`application_review/${id}`);
};

export const GetCheckoutData = async (id) => {
  return await axiosInstance.get(`checkout/${id}`);
};

export const ApplyCouponCode = async (id, code) => {
  return await axiosInstance.get(`checkout/${id}/${code}`);
};

export const GetRenewCheckoutData = async (id) => {
  return await axiosInstance.get(`renew_checkout/${id}`);
};

export const GetUpgradeCheckoutData = async (id) => {
  return await axiosInstance.get(`checkout_upgrade/${id}`);
};

export const paymentSuccessService = async (data) => {
  return await axiosInstance.post("PaymentSuccess", data);
};

export const paymentFailureService = async (data) => {
  return await axiosInstance.post("unsuccessful", data);
};
